import { render, staticRenderFns } from "./FluxRegaloStep1.vue?vue&type=template&id=23c22a08"
import script from "./FluxRegaloStep1.vue?vue&type=script&lang=js"
export * from "./FluxRegaloStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports